export enum RoleType {
  FOLLOW_UP_SUPERVISOR = '1',
  ADMIN = '2',
  HUB_PLATFORM = '3',
  TRACKING_AGENT = '4',
  BASIC_ADMIN = '5',
  PLUS_ADMIN = '6',
}
